/**
 * 将模板中的占位符替换为 locale 中的对应文本。
 * 支持嵌套键（命名空间.键），例如模板中的 {{common.companyName}} 会读取
 * locale['common']['companyName']。
 *
 * 支持「占位符的值里再含占位符」的二次填充（最多 3 轮），例如
 * locale 的 member.title 取值为 "{{common.appName}} Membership Agreement" 时，
 * 会先被替换成 "WhisperAi Membership Agreement"。
 *
 * 未提供的键将原样保留（match 不变），便于排查。
 *
 * @param {string} template 语言无关的 HTML 模板（含 {{ns.key}} 占位符）
 * @param {object} locale   当前语言的文案对象（嵌套结构）
 * @returns {string}
 */
export function fillTemplate(template, locale = {}) {
  if (!template) return ''
  let result = String(template)
  // 最多 3 轮，处理值中嵌套的占位符
  for (let i = 0; i < 3; i++) {
    let changed = false
    result = result.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (match, path) => {
      const value = path.split('.').reduce((obj, key) => {
        return obj == null ? obj : obj[key]
      }, locale)
      if (value !== undefined) {
        if (value !== match) changed = true
        return value
      }
      return match
    })
    if (!changed) break
  }
  return result
}

export default fillTemplate
